import Product from '@customTypes/product';
import React from 'react';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import styles from '@components/ProductDetails/ProductDetailsVariant/Components/ProductDescription.module.css';

type Props = {
  product: Product;
};

export default function ProductDescription({ product }: Props) {
  return (
    <div className="mt-6">
      <p className="text-17px font-rp-pn-semi-bold font-semibold text-custom-black leading-21px mb-23px">
        {product.name} Details
      </p>

      <div className={`flex flex-col ${styles.markDownList}`}>
        <ReactMarkdown>{product.description}</ReactMarkdown>
      </div>
    </div>
  );
}
